var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotes(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 50,
    viewBox: "0 0 41 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1375_7223)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.808 43.8625V43.8625C10.1569 43.9529 9.56833 43.4656 9.53563 42.8091L7.8863 9.70034C7.82713 8.51259 8.74179 7.50165 9.92951 7.44204L32.4862 6.30995C33.6601 6.25104 34.6644 7.14407 34.7432 8.31676L34.9042 10.7134",
    stroke: "#333333",
    strokeWidth: 0.646154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3486 11.8059C10.3045 10.6396 11.1974 9.65043 12.362 9.5752L36.2102 8.03461C37.4518 7.9544 38.5029 8.9398 38.5029 10.184V44.2893C38.5029 45.4788 37.5386 46.4432 36.349 46.4432H25.0799H13.7309C12.573 46.4432 11.6223 45.5277 11.5786 44.3706L10.3486 11.8059Z",
    fill: "#FFE7C6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.9492,
    y: 12.6301,
    width: 26.8046,
    height: 36.2431,
    rx: 1.83077,
    stroke: "#333333",
    strokeWidth: 0.646154
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.75991 36.6942L1.48801 6.791C1.31962 5.61224 2.13963 4.5205 3.31863 4.35377L25.6936 1.18963C26.8756 1.02249 27.968 1.84849 28.1293 3.03125L28.2407 3.84809",
    stroke: "#333333",
    strokeWidth: 0.646154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1375_7223"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39.1538,
    height: 48.427,
    fill: "white",
    transform: "translate(0.923096 0.769234)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotes);
export default __webpack_public_path__ + "static/media/notes.1ffca522f32f44a8f4693cdeebdd4159.svg";
export { ForwardRef as ReactComponent };